import React from 'react';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { IconButtonProps, SxProps, Theme } from '@mui/material';

import { StyledCollapseButton } from './styled';

interface PropsType extends IconButtonProps {
	isCollapsed: boolean;
	onClick?: () => void;
	color?:
		| 'inherit'
		| 'default'
		| 'primary'
		| 'secondary'
		| 'error'
		| 'info'
		| 'success'
		| 'warning'; // @ToDo import from theme
	openColor?: (theme: Theme) => string;
	collapsedColor?: (theme: Theme) => string;
	sx?: SxProps;
}

function CollapseButton({ isCollapsed, onClick, openColor, collapsedColor, ...props }: PropsType) {
	return (
		<StyledCollapseButton onClick={onClick} {...props}>
			<KeyboardArrowUpIcon
				sx={(theme) => ({
					transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
					transition: 'all .3s',
					color: isCollapsed
						? openColor || theme.palette.text.helper
						: collapsedColor || theme.palette.text.white,
				})}
			/>
		</StyledCollapseButton>
	);
}

export default CollapseButton;
